import { Component } from '@angular/core';
import { IonicPage, NavParams, ViewController } from 'ionic-angular';
import { LoggerEvent, LoggerProvider } from '../../providers/logger/logger';
import { SegmentProvider } from '../../providers/analytics/segment';
import { RouteProvider } from '../../providers/route/route';
import { WalletProvider } from '../../providers/wallet/wallet';
import { WALLET_ACTIVATION_RETVAL } from '../../providers/myria/app-variables';
import { LoadingProvider } from '../../providers/loading/loading';
import { AnalyticsEventType } from '../../model/types/analytics.const';
import { LoginProvider } from '../../providers/myria/login-provider';

@IonicPage()
@Component({
  selector: 'wallet-not-active',
  templateUrl: 'wallet-not-active.html'
})
export class WalletNotActivePage {
  paymentMethods;
  isModal = false;
  isUserVerified = false;
  isShowTerms = false;
  imgSrc = '';
  headerKey = '';
  contentKey = '';
  buttonTextKey = '';
  sourceLocation = 'Activate Wallet Flow';//old init var
  constructor(
    private analytics: SegmentProvider,
    private viewCtrl: ViewController,
    private routeProvider: RouteProvider,
    private walletProvider: WalletProvider,
    private loadingProvider: LoadingProvider,
    private loginProvider: LoginProvider,
    private navParams: NavParams
  ) {
    this.isModal = this.navParams.get('isModal');
    if(this.navParams.get('sourceLocation'))
      this.sourceLocation = this.navParams.get('sourceLocation');
  }

  activateWallet() {
    this.analytics.trackEvent({ eventName: AnalyticsEventType.WalletActivateStarted });
    // Go to Confirm PIN Page
    this.routeProvider.openModal(this.routeProvider.pages.WalletPinPage, { sourceLocation: this.sourceLocation }, (pin) => this.walletProvider.onActivateWalletResult(pin));
  }

  async identityVerification() {
    const result = await this.walletProvider.isUserCanTransactAndCanEKYC();
    if (result && result === true)
      this.routeProvider.openModal(this.routeProvider.pages.VerifyIdentitySelectionPage, { isFromSMF: this.isModal });
    else
      this.routeProvider.openModal(this.routeProvider.pages.VerifyIdentityInStorePage);
  }

  buttonClickAction() {
    if (this.isUserVerified) {
      this.activateWallet();
    } else {
      this.identityVerification();
    }
  }

  ionViewWillEnter() {
    this.init();
  }
  async init() {
    this.isUserVerified = await this.walletProvider.isUserVerified(); // this.navParams.get('isKyced');
    var fromPage = this.routeProvider.getPreviousPageName();
    // var activateWalletHeader = 'page.eWalletPage.eWalletHomeHeader';
    // if(fromPage === this.routeProvider.pages.CheckPricesSelectActionsheet.page){
    //   activateWalletHeader = 'page.eWalletPage.eWalletActivationHomeHeader';
    // }
    this.imgSrc = 'assets/imgs/wallet-home.svg';
    if (this.isUserVerified) {
      this.headerKey = 'page.eWalletPage.eWalletHomeHeader';//activateWalletHeader;
      this.contentKey = 'page.eWalletPage.eWalletHomeBody';
      this.buttonTextKey = 'page.eWalletPage.activateWalletButton';
      this.isShowTerms = true;
    } else {
      this.headerKey = 'page.eWalletPage.eWalletActivateHeader';
      this.contentKey = 'page.eWalletPage.eWalletActivateBody';
      this.buttonTextKey = 'page.activityPage.genericSendMoneyNowButton';
      this.isShowTerms = false;
    }
  }
  
  notNowClick(){ 
    this.viewCtrl.dismiss();
  }
}



// WEBPACK FOOTER //
// ./src/pages/wallet-not-active/wallet-not-active.ts